import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a9f91a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-1 w-full mt-0 mb-2",
  "data-cy": "pdf-overview-generalinfo-table"
}
const _hoisted_2 = {
  class: "data-tr border-top border-bottom",
  "data-cy": "generalinfo-table-heizzentrale"
}
const _hoisted_3 = {
  style: {"min-width":"120px","max-width":"200px"},
  class: "pl-2"
}
const _hoisted_4 = {
  style: {"min-width":"120px","max-width":"200px"},
  class: "pl-2"
}
const _hoisted_5 = { "data-cy": "generalInfo-standort" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = {
  style: {"min-width":"120px","max-width":"200px"},
  class: "pl-2"
}
const _hoisted_8 = { "data-cy": "generalInfo-zugangsart" }
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = {
  style: {"min-width":"120px","max-width":"200px"},
  class: "pl-2"
}
const _hoisted_11 = { "data-cy": "generalInfo-heizraumtuer" }
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = {
  class: "data-tr",
  "data-cy": "generalinfo-table-waermeerzeuger"
}
const _hoisted_14 = ["rowspan"]
const _hoisted_15 = {
  style: {"min-width":"120px","max-width":"200px"},
  class: "pl-2 border-bottom"
}
const _hoisted_16 = { "data-cy": "generalInfo-energietraeger" }
const _hoisted_17 = { class: "font-semibold" }
const _hoisted_18 = { class: "pl-2 border-bottom" }
const _hoisted_19 = {
  key: 0,
  class: "text-xxs h-2.5"
}
const _hoisted_20 = { class: "pl-2 border-bottom" }
const _hoisted_21 = {
  key: 0,
  class: "h-2.5"
}
const _hoisted_22 = { "data-cy": "generalinfo-table-anlagenkomponenten" }
const _hoisted_23 = {
  colspan: "3",
  class: "pl-2"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tr", _hoisted_2, [
      _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.t("hzba.pdf.heizzentrale", 1, { locale: _ctx.lang })), 1),
      _createElementVNode("td", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.useIdentifierFrageFinder(
              _ctx.hzba,
              "hzba.heizzentrale-tab.allgemein-group.allgemein-modal.allgemein.standort"
            )?.getTitle() || "Standort") + ": ", 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.hzba,
                "hzba.heizzentrale-tab.allgemein-group.allgemein-modal.allgemein.standort"
              )?.getSelectedAuswahlLabelsString() || "Keine Angabe"), 1)
        ])
      ]),
      _createElementVNode("td", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createTextVNode(_toDisplayString(_ctx.useIdentifierFrageFinder(
              _ctx.hzba,
              "hzba.heizzentrale-tab.allgemein-group.allgemein-modal.allgemein.zugangsart"
            )?.getTitle()) + ": ", 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.hzba,
                "hzba.heizzentrale-tab.allgemein-group.allgemein-modal.allgemein.zugangsart"
              )?.getSelectedAuswahlLabelsString() || "-"), 1)
        ])
      ]),
      _createElementVNode("td", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createTextVNode(_toDisplayString(_ctx.t("hzba.pdf.heizraumtuer", 1, { locale: _ctx.lang })) + ": ", 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.isBeschildert === true
                ? "Beschildert"
                : _ctx.isBeschildert === false
                  ? "Nicht beschildert"
                  : "Keine Angabe"), 1)
        ])
      ])
    ]),
    _createElementVNode("tr", _hoisted_13, [
      _createElementVNode("td", {
        style: {"min-width":"120px","max-width":"200px"},
        class: "pl-2",
        rowspan: _ctx.waermeerzeugers?.length + 2
      }, _toDisplayString(_ctx.t("hzba.pdf.waermeerzeugung", 1, { locale: _ctx.lang })), 9, _hoisted_14),
      _createElementVNode("td", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.useIdentifierFrageFinder(
              _ctx.hzba,
              "hzba.uebersicht-tab.heizungsdaten.energietraeger"
            )?.getTitle()) + ": ", 1),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.hzba,
                "hzba.uebersicht-tab.heizungsdaten.energietraeger"
              )?.getSelectedAuswahlLabelsString()), 1)
        ])
      ]),
      _createElementVNode("td", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.waermeerzeugers?.slice(0, 5), (waermeerzeuger, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            "data-cy": "generalInfo-leistung"
          }, [
            _createTextVNode(" Wärmeerzeuger " + _toDisplayString(key + 1) + ": Leistung: ", 1),
            _createElementVNode("strong", null, _toDisplayString(waermeerzeuger
                .findFrageByRelativePath(
                  _ctx.hzba,
                  "allgemein-modal.allgemein.nennleistung"
                )
                ?.getCurrentInput() || "-") + " kW ", 1)
          ]))
        }), 128)),
        (_ctx.waermeerzeugers?.length > 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Weitere Wärmeerzeuger wurden gefunden. "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("td", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.waermeerzeugers?.slice(0, 5), (waermeerzeuger, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            "data-cy": "generalInfo-baujahr"
          }, [
            _createTextVNode(" Baujahr: "),
            _createElementVNode("strong", null, _toDisplayString(waermeerzeuger
              .findFrageByRelativePath(
                _ctx.hzba,
                "allgemein-modal.allgemein.baujahr"
              )
              ?.getCurrentInput() || "-"), 1)
          ]))
        }), 128)),
        (_ctx.waermeerzeugers?.length > 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("tr", _hoisted_22, [
      _createElementVNode("td", _hoisted_23, [
        _createElementVNode("div", null, _toDisplayString(_ctx.useIdentifierFrageFinder(
              _ctx.hzba,
              "hzba.uebersicht-tab.anlagenschema-group.kurzbeschreibunganlagenkomponenten"
            )?.getCurrentInput()), 1)
      ])
    ]),
    _hoisted_24
  ]))
}